import React from "react";

const SvgDropdownOpened = props => <svg fill="none" viewBox="0 0 16 16" {...props}><path fill="#0B0D0E" fillRule="evenodd" d="M5.414 10c-.89 0-1.337-1.077-.707-1.707l2.586-2.586a1 1 0 0 1 1.414 0l2.586 2.586c.63.63.184 1.707-.707 1.707H5.414z" clipRule="evenodd" /></svg>;

export default SvgDropdownOpened;